import { render, staticRenderFns } from "./com-card.vue?vue&type=template&id=344fa1c1&scoped=true&"
import script from "./com-card.vue?vue&type=script&lang=js&"
export * from "./com-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344fa1c1",
  null
  
)

export default component.exports